<template>
	<div v-bind:class="rootClass">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">			
			<top-nevleft></top-nevleft>
		 <b-col class="inmobilevPadding">
			<!-- <b-row class="breadcrumbrow mt-1 mb-2">				
				<b-col >
				 <h5 class="text-center">Sales Advisor Dashboard</h5>
				</b-col>				
			</b-row>-->
			<b-row class=" mt-1 m-0 tabtitlemo" v-if="tabtitle!=''">				
				<b-col >
				 <h5 class="text-center">{{tabtitle}}</h5>
				</b-col>				
			</b-row>
			
		<!-- <b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
					<h3>My Shop</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
                    <b-button variant="dark" pill  @click="triggerimportcsv()"><b-icon class="mr-2" icon="upload" aria-hidden="true"></b-icon>Upload CSV</b-button>
                    <b-form-file type="file" class="importfile" style="display:none" v-model="product_csv" accept=".csv" @change="uploadfile()"></b-form-file>
				</b-col>
			</b-row>
		</b-container> -->
		<b-container fluid >
			<b-row class="mt-4">
				<b-col class="col-md-12 col-sm-12 col-xs-12 inmobilevPadding">
					<b-tabs content-class="mt-3 ">
						<b-tab active @click="tabtitle='Product List',productAllPopup=products">
							<template slot="title">
							  <span class="d-block d-sm-block d-md-none" ><i class="fa fa-product-hunt" aria-hidden="true"></i></span>
							  <span class="d-none d-md-block">My Shop</span>
							</template>
						
							<b-card class="mb-3">
						
							
							<b-table show-empty sticky-header   :stacked="[{'md' : stackedIs}]" :responsive="responseiv"  :items="products" :fields="productsfields" :current-page="currentPage" :per-page="perPage">
							
							<!-- <b-table show-empty sticky-header :stacked="[{'md' : stacked}]"  :responsive="responseiv"  :items="products" :fields="productsfields">  -->
								
								<template v-slot:cell(image)="rowImage">
									<b-img v-bind="thumbnailProps" rounded alt="" v-if="rowImage.value==''" :src="$root.MEDIAPATH+'blank.jpg'">{{rowImage}}</b-img>
									<b-img-lazy v-bind="thumbnailProps" rounded alt="" v-else :src="$root.MEDIAAPI+'toolimage/get_image?size=120x120&src='+rowImage.value">{{rowImage}}</b-img-lazy>
									<p> 
										<ul class="p-0 d-block d-sm-block d-md-none">
											<li style="height:15px;"><small>{{'Seller : '+rowImage.item.shopname}}</small></li>
											<li><small>{{'Brand : '+rowImage.item.brand}}</small></li>
											<li>
											<product-rating :userrating="rowImage.item.total_rating" style="width:100%;"></product-rating>
											</li>
											<li>
												<b-link class="create-list-cta d-flex align-items-center" v-b-modal="'create-list-modal'" @click="$root.updateShareshop(rowImage.item),$root.sharepopup()" >
										<div class="icon-wrapper d-flex flex-column justify-content-center align-items-center mr-2"
										> <b-icon icon="plus"></b-icon>	</div><span>Create List</span> </b-link>
											</li>
										</ul>								  
									</p>

									
								</template>
								<template v-slot:cell(title)="rowTitle">
									<div class="titleP">
									{{rowTitle.value}}
									</div>
									<p class="d-none d-md-block">
										<ul class="p-0 ">
											<li style="height:15px;"><small>{{'Seller : '+rowTitle.item.shopname}}</small></li>
											<li><small>{{'Brand : '+rowTitle.item.brand}}</small></li>
											<li>
											<product-rating :userrating="rowTitle.item.total_rating" style="width:45%;"></product-rating>
											</li>
											<li>
												<b-link class="create-list-cta d-flex align-items-center"			v-b-modal="'create-list-modal'" @click="$root.updateShareshop(rowTitle.item),$root.sharepopup()" >
										<div class="icon-wrapper d-flex flex-column justify-content-center align-items-center mr-2"
										> <b-icon icon="plus"></b-icon>	</div><span>Create List</span> </b-link>
											</li>
										</ul>
									</p>
									<ul class="p-0 d-block d-sm-block d-md-none">
										<li>Price:<strong>{{$root.currency()+$root.tofixed((rowTitle.item.price ), 2)}}</strong></li>
										<li>Special Price: <strong>{{$root.currency()+$root.tofixed((rowTitle.item.special_price ), 2)}}</strong></li>
										<li>
										Commission: <strong>{{rowTitle.item.commission?rowTitle.item.commission+'%':'0%'}}</strong>
										
										</li>
										<li>
										Discount: <strong>{{rowTitle.item.discount?rowTitle.item.discount+'%':'0%'}}</strong>
										</li>
										  <shareicon-button :productData="rowTitle.item"  iamin="myshop"></shareicon-button>
									</ul>	
								</template>
								
								<template v-slot:cell(price)="rowPrice">
									{{$root.currency()+$root.tofixed((rowPrice.item.price ), 2)}}
									  <shareicon-button :productData="rowPrice.item"  iamin="myshop"></shareicon-button>
									
								</template>
								<template v-slot:cell(special_price)="rowPricesp">
									{{$root.currency()+$root.tofixed((rowPricesp.item.special_price ), 2)}}									
								</template>
							</b-table>
							<b-row class="px-3">
								<b-col lg="6" class="text-left">
									<span class="mr-2">Showing {{currentPage}} to {{(perPage>products.length)?products.length:perPage}} of {{products.length}} entries</span>
								</b-col>
								<b-col lg="3" offset-md="3">
									<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
								</b-col>
							</b-row>
							
							</b-card>
						</b-tab>
						<b-tab @click="tabtitle='Shared List',productAllPopup=$root.share.shared_list">
						<template slot="title">
						  <span class="d-block d-sm-block d-md-none" ><i class="fa fa-share-alt" aria-hidden="true"></i></span>
						  <span class="d-none d-md-block">Shared List</span>
						</template>
							<!--<recommended-product :recommendedProduct="$root.share.shared_list" :stackedIs="stackedIs"></recommended-product>-->
							
							<newarrival-product :newarrivalProduct="$root.share.shared_list" :stackedIs="stackedIs"></newarrival-product>
						</b-tab>
						<b-tab @click="tabtitle='Top Recommended',productAllPopup=$root.share.recommended">
						<template slot="title">
						  <span class="d-block d-sm-block d-md-none" ><i class="fa fa-thumbs-up" aria-hidden="true"></i></span>
						  <span class="d-none d-md-block">Top Recommended</span>
						</template>
							<!-- <recommended-product :recommendedProduct="$root.share.recommended" :stackedIs="stackedIs"></recommended-product>-->
							
							<newarrival-product :newarrivalProduct="$root.share.recommended" :stackedIs="stackedIs"></newarrival-product>
						</b-tab>
						
						<b-tab @click="tabtitle='Favorites',productAllPopup=$root.share.favorites">
							<template slot="title">
							  <span class="d-block d-sm-block d-md-none" ><i class="fa fa-heart" aria-hidden="true"></i></span>
							  <span class="d-none d-md-block">Favorites</span>
							</template>
							<!--<favorites-product :favoritesProduct="$root.share.favorites" :stackedIs="stackedIs"></favorites-product>-->
							<newarrival-product :newarrivalProduct="$root.share.favorites" :stackedIs="stackedIs"></newarrival-product>
						</b-tab>
						<b-tab @click="tabtitle='Top Selling',productAllPopup=$root.share.topselling ">
						<template slot="title"> 
						  <span class="d-block d-sm-block d-md-none" ><i class="fa fa-bar-chart" aria-hidden="true"></i></span>
						  <span class="d-none d-md-block">Top Selling</span>
						</template>
						<!--<topselling-product :topsellingProduct="$root.share.topselling" :stackedIs="stackedIs"></topselling-product>-->
						
						<newarrival-product :newarrivalProduct="$root.share.topselling" :stackedIs="stackedIs"></newarrival-product>
						</b-tab>
						<b-tab @click="tabtitle='New Arrival',productAllPopup=$root.share.newarrival">
						<template slot="title">
						  <span class="d-block d-sm-block d-md-none" ><i class="fa fa fa-hand-lizard-o" aria-hidden="true"></i></span>
						  <span class="d-none d-md-block">New Arrival</span>
						</template>
						<newarrival-product :newarrivalProduct="$root.share.newarrival" :stackedIs="stackedIs"></newarrival-product>
						
						</b-tab>
						<!--<b-tab title="Vouchers" disabled>
							<template slot="title">
						  <span class="d-block d-sm-block d-md-none" ><i class="fa fa-list" aria-hidden="true"></i></span>
						  <span class="d-none d-md-block">Vouchers</span>
						</template>
						</b-tab> -->
					</b-tabs>
				</b-col>
			</b-row>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		<!--<top-footer></top-footer>-->
		</b-col>
		</b-row>
		</b-container>
		<share-popup :cartItems="$root.share.shopshareitems"  :cartData="$root.share.shopshareitems" :cartTotalqty="$root.share.shopshareitems.length" :productAll="productAllPopup"></share-popup>
	</div>
	
</template>
<script>
//import Header from "@/components/agent/Header.vue";
import Header from "@/components/header.vue";
//import Footer from "@/components/footer-admin.vue";
import TreeviewPage from "@/components/agent/nevleft.vue";
//import Recommended from "@/components/agent/recommended.vue";
//import FavoritesProduct from "@/components/agent/favorites.vue";
//import TopsellingProduct from "@/components/agent/topselling.vue";
import NewarrivalProduct from "@/components/agent/newarrival.vue";
import ProductRating from "@/components/product-rating.vue";
import SharePopup from "@/components/agent/share-popup.vue";
import ShareiconButton from "@/components/shareiconButton.vue";
import '@/assets/myshop.scss';
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		//"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		//"recommended-product": Recommended,
		//"favorites-product": FavoritesProduct,
		//"topselling-product": TopsellingProduct,
		"newarrival-product": NewarrivalProduct,
		"product-rating": ProductRating,
		"share-popup": SharePopup,
		"shareicon-button": ShareiconButton,
	},
	mounted(){
		console.log('==WISTH=='+screen.width);
		if(screen.width<=640){
			this.rootClass='myshopShop';
			this.stackedIs=false;
			this.responseiv=true;
			this.thumbnailProps={ blank: false, width: 120, height: 120, class: 'm1' };
		}else{
			this.rootClass='myshop';
		}
		//var self = this;
		//Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		return{
			rootClass:'myshop',
			tabtitle:'Product List',
			stackedIs:true,
			responseiv:false,
            loading: true, 
            thumbnailProps: { blank: false, width: 120, height: 120, class: 'm1' },
            product_csv: null,
			/*product_glb: '',*/
			model_maps: {},
			recordUrl: this.$root.WEBAPI+'agentapi/my-shop',
			insertUrl: this.$root.NEWAPIURL+'sellerapi/promotion-import',
			products: [],
			categoryOptions: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Products',
					active: true
				}
			],
			productsfields: [ 
                { key: 'image', label: 'Image', class:'text-center radiushF pricing-columnNoboder'},
				{ key: 'title', label: 'Product Title',class:' pricing-column nameOfTheClass'},
				/*{ key: 'shopname', label: 'Seller'},*/ 
                { key: 'price', label: 'Price',class:'text-center pricing-column colDisplaynone'},
                { key: 'special_price', label: 'Special Price',class:'text-center pricing-column colDisplaynone'},
				{ key: 'commission', label: 'Commission', class: 'text-center pricing-column colDisplaynone',
					formatter: (value) => { 
						if(value == '' || value == 0){
							return value = '10%';
						}
						return value+'%';
					},
				},
				{ key: 'discount', label: 'Discounts', class: 'text-center pricing-columnNoboder colDisplaynone',
					formatter: (value) => { 
						if(value == '' || value == 0){
							return value = '0%';
						}
						return value+'%';
					},
				},
				/*{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' } */
            ],
            itemfields:[
                { key: 'product_id', label: 'PID'},
                { key: 'sku', label: 'SKU'},
                { key: 'total_images', label: 'TOTAL IMAGES'},
				{ key: 'status', label: 'Status' },
            ],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			
			emptyItem: {
				id: 0,
				product_id: '',
				title: '',
				short_description: '',
				description: '',
				sku: '',
				category: '',
				price: '',
				special_price: '',
				product_data:{},
				tier_price: [],
                status: 0
			},
			counterindex:1,
			/* share And Recommended*/
			 selectedRecommendCategory: '',
            recommendedCategory: [],
            toprecommended: [],
            popupOpened: false,
            selectedItem: {
                gallery_images: [],
                price: 0,
                special_price: 0,
            },
			/*------------------*/
			productAllPopup:[],
		};

	},
	methods: {
		
        triggerimportcsv(){
            //this.$refs.importfile.click();
            document.getElementsByClassName('importfile')[0].querySelector('input').click();
        },
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.products = response.data.result.products;
					
					
					self.loading = false;
					self.totalRows = self.products.length;
						
					var res = response.data;
					self.$root.share.recommended = [];
                    self.$root.share.favorites = res.result.favorites;
                    self.$root.share.topselling = res.result.topselling;
                    self.$root.share.newarrival = res.result.newarrival;
                    self.$root.share.shared_list = res.result.shared_list;

                    self.toprecommended = res.result.recommended;

                    self.recommendedCategory = res.result.category;
                    self.selectedRecommendCategory = self.recommendedCategory[0].title;
					/* ORG recommended 
						//self.$root.share.recommended=self.toprecommended[self.recommendedCategory[0].id];
					*/
                    self.$root.share.recommended=self.toprecommended;
					self.productAllPopup = self.products;
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		importcsv(){
			//fdhgkjhg
		}
	}
}
</script>
<style>
</style>